var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockchainIcon02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 198.4 198.4",
    style: {
      enableBackground: "new 0 0 198.4 198.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,93c6.7,6.7,15.6,10.1,24.5,10.1c6.1,0,12.2-1.6,17.7-4.8l14.1,14.1c-7.8,13.3-6,30.6,5.3,42l23.9,23.9 c6.7,6.7,15.6,10.1,24.5,10.1c8.9,0,17.7-3.4,24.5-10.1c13.5-13.5,13.5-35.4,0-48.9l-23.9-23.9c-11.4-11.4-28.9-13.2-42.2-5.2 L98.2,86.2c3.2-5.3,4.8-11.3,4.8-17.7c0-9.2-3.6-17.9-10.1-24.5L69,20.2c-6.5-6.5-15.2-10.1-24.5-10.1s-17.9,3.6-24.5,10.1 C13.6,26.7,10,35.4,10,44.6s3.6,17.9,10.1,24.5L44,93z M113.1,125.3l13.2,13.2c1.7,1.7,3.9,2.5,6.1,2.5c2.2,0,4.4-0.8,6.1-2.5 c3.3-3.3,3.3-8.8,0-12.1l-13.3-13.3c1.6-0.5,3.2-0.7,4.8-0.7c4.5,0,9,1.7,12.4,5.1l23.9,23.9c6.8,6.8,6.8,17.9,0,24.7 c-6.8,6.8-17.9,6.8-24.7,0l-23.9-23.9C113.1,137.7,111.6,131.2,113.1,125.3z M32.2,32.3c3.3-3.3,7.7-5.1,12.4-5.1 c4.7,0,9.1,1.8,12.4,5.1l23.9,23.9c3.3,3.3,5.1,7.7,5.1,12.4c0,1.6-0.2,3.2-0.6,4.7L74.7,62.7c-3.3-3.3-8.8-3.3-12.1,0 c-3.3,3.3-3.3,8.8,0,12.1l10.5,10.5c-5.9,1.6-12.5,0.2-17.1-4.5L32.2,57C25.4,50.2,25.4,39.1,32.2,32.3z",
    fill: "#E50053"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainIcon02);
export default __webpack_public_path__ + "static/media/Blockchain_Icon_02.cd9cf92669498527fc3122053d3ecbf4.svg";
export { ForwardRef as ReactComponent };